import { Offer, Package } from '@spilca/order_ts/v1/order/model_offer_pb';
import {
  productConstructor,
  auditConstructor,
  orderConstructor
} from '@monorepo/orders';
import discountConstructor from '../discountConstructor';
import offerConditionConstructor from '../offerConditionConstructor';
import fileListConstructor from '../fileListConstructor';
import offerResultConstructor from '../offerResultConstructor';
import vatConditionConstructor from '../vatConditionConstructor';

const offerConstructor = ({
  multiOrderId,
  id,
  name,
  status,
  order,
  product,
  currency,
  price,
  discount,
  discountAmount,
  totalAmount,
  condition,
  offerFilesList,
  result,
  additionalConditions,
  description,
  audit,
  vatApplied,
  vatCondition,
  deliveryPriceApplied,
  packageIdsList,
  packaging
}: Partial<Offer.AsObject>): Offer => {
  const offer = new Offer();
  if (multiOrderId) {
    offer.setMultiOrderId(multiOrderId);
  }
  if (id) {
    offer.setId(id);
  }
  if (name) {
    offer.setName(name);
  }
  if (status) {
    offer.setStatus(status);
  }
  if (order) {
    offer.setOrder(orderConstructor(order));
  }
  if (product) {
    offer.setProduct(productConstructor(product));
  }
  if (currency || order?.currency) {
    offer.setCurrency(currency || order?.currency);
  }
  if (price || order?.price) {
    offer.setPrice(price || order?.price);
  }
  if (discount) {
    offer.setDiscount(discountConstructor(discount));
  }
  if (discountAmount) {
    offer.setDiscountAmount(discountAmount);
  }
  if (totalAmount) {
    offer.setTotalAmount(totalAmount);
  }
  if (condition) {
    offer.setCondition(offerConditionConstructor(condition));
  }
  if (offerFilesList) {
    offer.setOfferFilesList(fileListConstructor(offerFilesList));
  }
  if (result) {
    offer.setResult(offerResultConstructor(result));
  }
  if (additionalConditions) {
    offer.setAdditionalConditions(additionalConditions);
  }
  if (description) {
    offer.setDescription(description);
  }
  if (audit) {
    offer.setAudit(auditConstructor(audit));
  }
  if (order?.vatApplied) {
    offer.setVatApplied(order?.vatApplied);
  }
  if (order?.deliveryPriceApplied) {
    offer.setDeliveryPriceApplied(order?.deliveryPriceApplied);
  }
  if (vatApplied?.toString() === 'true') {
    offer.setVatApplied(true);
  }
  if (vatApplied?.toString() === 'false') {
    offer.setVatApplied(false);
  }
  if (deliveryPriceApplied?.toString() === 'true') {
    offer.setDeliveryPriceApplied(true);
  }
  if (deliveryPriceApplied?.toString() === 'false') {
    offer.setDeliveryPriceApplied(false);
  }
  if (vatCondition) {
    offer.setVatCondition(vatConditionConstructor(vatCondition));
  }

  if (packaging) {
    offer.setPackaging(packaging);
  }

  if (packageIdsList && packageIdsList.length > 0) {
    const pkgMessages = packageIdsList.map((p) => {
      const pkg = new Package();
      pkg.setPackageId(p.packageId);
      pkg.setAmount(p.amount);
      // @ts-ignore
      if (p.warehouseId != null && (pkg as any).setWarehouseId) {
        // @ts-ignore
        (pkg as any).setWarehouseId(p.warehouseId);
      }

      return pkg;
    });

    offer.setPackageIdsList(pkgMessages);
  } else {
    offer.setPackageIdsList([]);
  }
  return offer;
};

export default offerConstructor;
